import { animated, useSpring } from '@react-spring/web'
import styles from './Answer.module.css'

export const AnswerLoading = () => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
    })
    return (
        <animated.div style={{ ...animatedStyles }}>
            <div className={styles.answerContainer}>
                <div>
                    <p className={styles.answerText}>
                        Generating answer
                        <span className={styles.loadingdots} />
                    </p>
                </div>
            </div>
        </animated.div>
    )
}
